module.exports = __webpack_public_path__ + "img/image-placeholder.4527432e.svg";